import { Component, Input, EventEmitter, Output, ViewChild, ElementRef } from '@angular/core';
import { ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { CollectionService } from './../../../base-services/collection.service';
import { BaseDataService } from './../../../base-services/base-data.service';
import { BaseDropdown } from './../base-dropdown';
import { BaseEntity } from './../../../base-models/base-entity';
import { ModalService } from '../../../base-services/modal.service';
import { ModelDataService } from '../../../base-services/model-data.service';
import { MakeProvider } from '../../abstract-custom-control';
import { Subject, Observable, BehaviorSubject, combineLatest, Subscription } from 'rxjs';
import { UserRightsService } from '../../../base-services/user-rights.service';
import { TranslateService } from '@ngx-translate/core';
import { filter, startWith } from 'rxjs/operators';

@Component({
    selector: 'yt-multiselect',
    templateUrl: './multiselect.component.html',
    providers: [MakeProvider(MultiselectComponent)],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MultiselectComponent<T extends BaseEntity> extends BaseDropdown<T>{
    constructor(
        protected baseDataService: BaseDataService,
        public collectionService: CollectionService,
        protected modalService: ModalService,
        protected modelDataService: ModelDataService,
        protected changeDetectorRef: ChangeDetectorRef,
        protected userRightsService: UserRightsService,
        protected translateService: TranslateService
    ){
        super(baseDataService, collectionService, modalService, modelDataService, changeDetectorRef);
    }

    settings;
    displayValue;
    items1: T[];// = [
        //{ ID: 1, Naziv: 'weqwewqew' }
    //];

    allowAddNew: boolean = false;

    private _itemsLoaded: boolean = false;
    private _itemsLoadedSubject: Subject<boolean> = new Subject<boolean>();
    public multiselectDescription;

    @Input() SingleSelection: boolean = false;
    ItemsLoaded: Observable<boolean> = this._itemsLoadedSubject as Observable<boolean>;
    @Output() GetItems: EventEmitter<T[]> = new EventEmitter<T[]>();
    @Output() OnItemSelected = new EventEmitter();
    @ViewChild('select', /* TODO: add static flag */ { read: ElementRef, static: false }) selectControl: ElementRef;
    @ViewChild('multiSelect', { static: false }) multiSelect: any;

    ngOnInit(){
        this.settings = {
            singleSelection: this.SingleSelection,
            idField: 'ID',
            textField: this.ModelProperty,
            selectAllText: 'Sve',
            unSelectAllText: 'Sve',
            itemsShowLimit: 5,
            allowSearchFilter: true,
            enableCheckAll: true,
            searchPlaceholderText: 'Pretraga (uneti tekst za pretragu liste)',
            noDataAvailablePlaceholderText: 'Nema podataka'
        }

        super.ngOnInit();
     
        this.allowAddNew = this.AllowAddNew == null ? this.userRightsService.GetUserRightValue(this._modelData.MainList.UserRightsModelName.toLowerCase(), 'add') : this.AllowAddNew;

        this.itemsLoadedObservable
            .subscribe(() => {
                this.setDisabledState(true);
                this.items1 = null;
                if(this.Items){
                    this.Items.forEach(item => {
                        if(!this.items1)
                            this.items1 = new Array();
                        this.items1.push(item);
                })

                if(this.items1)
                    this.items1 = this.items1.slice();

                this.changeDetectorRef.detectChanges();

                this._itemsLoadedSubject.next(true);
                this.GetItems.emit(this.items1);
            }
                //this.changeDetectorRef.markForCheck();
                
                this.dropdownLoading = false;
                this.setDisabledState(false);
            })

            this.translateService.get(['MULTISELECT.DESCRIPTION.ALL']).subscribe(translate=>{this.multiselectDescription = translate['MULTISELECT.DESCRIPTION.ALL']})
    }

    

    focus() {
        setTimeout(() => {
            const dropdownInput = this.selectControl.nativeElement.querySelector('input');
            if (dropdownInput) {
              dropdownInput.focus(); 
            }
          }, 100); // Vreme čekanja se može prilagoditi
    }
    selectItem(item) {
        if (this.Type === 'ID' && this.displayValue) {
            this.value = [];
            this.displayValue.forEach(value => {
                this.value += value['ID'] + ',';
            });
            this.value = this.displayValue && this.displayValue.length > 0 ? this.value.substring(0, this.value.length - 1) : '';
            this.translateService.get(['MULTISELECT.DESCRIPTION.SELECTEDONE', 'MULTISELECT.DESCRIPTION.SELECTEDMULTIPLE'])
                .subscribe(translate=>{
                    this.multiselectDescription = this.displayValue.length === 1 ? (this.displayValue[0].SNaziv || this.displayValue[0].Naziv || translate['MULTISELECT.DESCRIPTION.SELECTEDONE']) : translate['MULTISELECT.DESCRIPTION.SELECTEDMULTIPLE'];
                })
            
        } else if (this.Type === 'NAME' && this.displayValue) {
            this.value = [];
            this.displayValue.forEach(value => {
                this.value += value[this.ModelProperty] + ',';
            });
            this.value = this.displayValue && this.displayValue.length > 0 ? this.value.substring(0, this.value.length - 1) : '';
        } else {
            this.value = this.displayValue;
        }
        this.OnItemSelected.emit(this.value); 
    }
    

    selectAll(items){
        if(items){
            this.value = '';
            // if(this.Type == 'ID' && this.displayValue){
            if(this.Type == 'ID'){
                    items.forEach(item => {
                    this.value += item.ID + ',';
                })
                this.value = this.value.length > 0 ? this.value.substring(0, this.value.length - 1) : '';
            }
            // else if(this.Type=='NAME' && this.displayValue){
            else if(this.Type=='NAME'){
                    items.forEach(item => {
                    this.value += item[this.ModelProperty] + ',';
                })
                this.value = this.value.length > 0 ? this.value.substring(0, this.value.length - 1) : '';
            } else {
                this.value = this.displayValue;
            }
            this.multiselectDescription = this.translateService.get(['MULTISELECT.DESCRIPTION.ALL']).subscribe(translate=>{translate['MULTISELECT.DESCRIPTION.ALL']})
        }
        this.OnItemSelected.emit(this.value);

    }

    deselectAll(items){
        this.value = null;
        this.OnItemSelected.emit(this.value);
        this.multiselectDescription = 'Nijedan';
    }

    // writeValue_old(value: any){
    //     super.writeValue(value);

    //     setTimeout(() => {
    //         //this._itemsLoadedSubject.subscribe(loaded => {
    //     if(value && value != '' && this.items1){
    //         this.displayValue = [];
    //         //value.toString().split(',').forEach(id => {
    //             //this.displayValue.push(this.items1.find(item => item.ID == parseInt(id)));
    //             if(this.Type == 'NAME'){
    //         value.toString().split(',').forEach(name => {
    //             this.displayValue.push(this.items1.find(item => item[this.ModelProperty] == name));
    //         })
    //     }
    //     else if(this.Type == 'ID'){
    //         value.toString().split(',').forEach(id => {
    //             this.displayValue.push(this.items1.find(item => item.ID == parseInt(id)));
    //         })
    //     }
    //     if(this.Type == 'NAME'){
    //         this.displayValue.forEach(value => {
    //             this.value += value[this.ModelProperty] + ',';
    //         })
    //         this.value = this.value != null && this.value.length > 0 ? this.value.substring(0, this.value.length - 1) : '';
    //         //})
    //     }
    //         this.changeDetectorRef.markForCheck();
    //     }
    // //})
    // }, 2000)
    // }
    dropdownLoading = true;
    writeValue(value: any) {
        super.writeValue(value);
        this.dropdownLoading = true;
        this.setDisabledState(true);
        setTimeout(() => {
          if (value && value !== '' && this.items1 && this.items1.length) {
                this.displayValue = [];
    
                const valuesArray = value.toString().split(',');
    
                if (this.Type === 'NAME') {
                    valuesArray.forEach(name => {
                        const foundItem = this.items1.find(item => item[this.ModelProperty] === name);
                        if (foundItem) {
                            this.displayValue.push(foundItem);
                        }
                    });
                } else if (this.Type === 'ID') {
                    valuesArray.forEach(id => {
                        const foundItem = this.items1.find(item => item.ID === parseInt(id, 10));
                        if (foundItem) {
                            this.displayValue.push(foundItem);
                        }
                    });
                }
    
                // Resetuj vrednost pre novog upisa
                this.value = '';
    
                // Rekonstruiši vrednost nakon pronađenih stavki
                if (this.Type === 'NAME') {
                    this.value = this.displayValue
                        .map(item => item[this.ModelProperty])
                        .join(',');
                } else if (this.Type === 'ID') {
                    this.value = this.displayValue
                        .map(item => item.ID)
                        .join(',');
                }
    
                // obavesti Angular o promeni
                if (this.onChange) {
                    this.onChange(this.value);
                }
                this.dropdownLoading = false;
                this.setDisabledState(false);
                
                this.changeDetectorRef.markForCheck();
          }
        //   this.dropdownLoading = false;
        //   this.setDisabledState(false);
        }, 2000);
    }
    OnItemAdded(item: T) {
        if (item) {
            if (!this.items1) {
                this.items1 = [];
            }
            
            this.items1.push(item);
            this.items1 = [...this.items1]; 

            const selektovan = {
                [this.settings.idField]: item[this.settings.idField],
                [this.settings.textField]: item[this.settings.textField]
            };
    
            // // this.displayValue = item;
            // this.displayValue.push({ID: item.ID, Naziv: item["Naziv"]});

            // const vecPostoji = this.displayValue.some(
            //     x => x[this.settings.idField] === selektovan[this.settings.idField]
            // );

            // const idField = this.settings.idField as keyof typeof selektovan; // ili 'id'
            // const vecPostoji = (this.displayValue).some(
            //     x => x[idField] === selektovan[idField]
            // );

            const idField = this.settings?.idField as keyof typeof selektovan; // ili 'id'
            const vecPostoji = (this.displayValue ?? []).some(
                x => x?.[idField] === selektovan?.[idField]
            );

            if (!vecPostoji) {
                // this.displayValue = [...this.displayValue, selektovan];
                const current = Array.isArray(this.displayValue) ? this.displayValue : [];
                this.displayValue = [...current, selektovan];
            }

    
            if (this.Type === 'ID' && this.displayValue) {
                this.value = [];
                this.displayValue.forEach(value => {
                    this.value += value['ID'] + ',';
                });
                // this.value = item.ID;
                 this.value = this.displayValue && this.displayValue.length > 0 ? this.value.substring(0, this.value.length - 1) : '';
                 this.translateService.get(['MULTISELECT.DESCRIPTION.SELECTEDONE', 'MULTISELECT.DESCRIPTION.SELECTEDMULTIPLE'])
                 .subscribe(translate=>{
                     this.multiselectDescription = this.displayValue.length === 1 ? (this.displayValue[0].SNaziv || this.displayValue[0].Naziv || translate['MULTISELECT.DESCRIPTION.SELECTEDONE']) : translate['MULTISELECT.DESCRIPTION.SELECTEDMULTIPLE'];
                 })
            } else if (this.Type === 'NAME' && this.displayValue) {
                this.value = [];
                 this.displayValue.forEach(value => {
                    this.value += value[this.ModelProperty] + ',';
                });
                // this.value = item[this.ModelProperty];
                this.value = this.displayValue && this.displayValue.length > 0 ? this.value.substring(0, this.value.length - 1) : '';
            }
            else {
                this.value = this.displayValue;
            }
            // this.OnItemSelected.emit(this.value); 
            this.changeDetectorRef.detectChanges();
             setTimeout(() => {
                this.multiSelect?.refreshDropdownList?.();
                this.OnItemSelected.emit(this.value); 
            });
            
        }
    }
    
    
    
}
